<template>
  <fragment>
    <div id="partner-filter" class="grid-column jc-b ai-c">
      <div class="grid-column jc-s ai-c gap-16">
        <img
          src="../../assets/img/general/svg/x-black.svg"
          alt="x"
          class="img-size-24 clickable"
          @click="close"
        >
        <div class="sac__font-16 bold">
          Filter Settings
        </div>
      </div>
      <button
        class="filter-btn"
        @click="applyPartnerFilters()"
      >
        <img
          src="../../assets/img/general/svg/check-white.svg"
          alt="x"
          class="img-size-24"
        >
        <span>Save</span>
      </button>
    </div>
    <div class="grid-row margin-top-16">
      <div>
        <SACDropdown
          field="psm"
          placeholder="All PSMs"
          :options="psmList"
          :value="partnerFilter.psm"
          :change="changePartnerFilter"
        />
        <div class="margin-top-16">
          <div class="sac__font-16 semi-bold">
            Account Type
          </div>
          <div class="grid-column ai-c">
            <div
              v-for="(item, idx) in typeOptions"
              :key="idx"
              :class="['filter-option', partnerFilter.type.includes(item) ? 'active' : '']"
              @click="changePartnerFilterType(item, partnerFilter.type.includes(item))"
            >
              {{ item }}
            </div>
          </div>
        </div>
        <div class="margin-top-16">
          <div class="sac__font-16 semi-bold">
            Engagement Level
          </div>
          <div class="grid-column ai-c">
            <div
              v-for="(item, idx) in levelOptions"
              :key="idx"
              :class="['filter-option', item === partnerFilter.engagementLevel ? 'active' : '']"
              @click="changePartnerFilter('engagementLevel', item)"
            >
              {{ item }}
            </div>
          </div>
        </div>
        <div class="margin-top-16">
          <div class="sac__font-16 semi-bold">
            Account Status
          </div>
          <div class="grid-column ai-c">
            <div
              v-for="(item, idx) in statusOptions"
              :key="idx"
              :class="['filter-option', item === partnerFilter.status ? 'active' : '']"
              @click="changePartnerFilter('status', item)"
            >
              {{ item }}
            </div>
          </div>
        </div>
      </div>
      <div class="sb-action">
        <div
          class="img-circle"
          @click="resetPartnerFilters()"
        >
          <img
            src="../../assets/img/general/svg/reset-icon.svg"
            alt="x"
            class="img-size-24"
          >
        </div>
        <div class="sac__font-16 semi-bold">
          Reset
        </div>
      </div>
    </div>
  </fragment>
</template>
<script>
import SACDropdown from '@shared/components/sac/SACDropdown.vue';
import adminMixin from '@shared/mixins/adminMixin';

export default {
  name: 'PartnerFilter',
  components: { SACDropdown },
  mixins: [adminMixin],
  props: {
    showPartnerFilter: Boolean,
    close: Function,
  },
  data() {
    return {
      typeOptions: ['New', 'Pilot', 'Partner', 'Other', 'Test'],
      levelOptions: ['Engaged', 'Unengaged'],
      statusOptions: ['Active', 'Deleted'],
      partnerFilter: {
        psm: '',
        type: [],
        engagementLevel: '',
        status: '',
      },
    };
  },
  computed: {
    psmList() {
      const { psmList } = this.$store.state.setting;
      const adminPSMOptions = psmList.map((p) => ({
        value: p.id,
        label: `${p.firstName} ${p.lastName}`,
      }));
      return adminPSMOptions;
    },
  },
  mounted() {
    this.partnerFilter = { ...this.adminFilter.partner };
  },
  methods: {
    applyPartnerFilters() {
      this.close();
      this.$store.dispatch('changeAdminValues', [{
        field: 'adminFilter',
        value: {
          ...this.adminFilter,
          partner: { ...this.partnerFilter },
        },
      }]);
      localStorage.setItem('adminFilter', JSON.stringify({
        ...this.adminFilter,
        partner: { ...this.partnerFilter },
      }));
    },
    resetPartnerFilters() {
      this.partnerFilter = {
        type: [],
        psm: '',
        engagementLevel: '',
        status: '',
      };
    },
    changePartnerFilter(field, value) {
      if (field === 'psm') {
        const selectedPsm = this.psmList.find((p) => p.value === value);
        this.partnerFilter[field] = value;
        this.partnerFilter.psmName = selectedPsm.label;
      } else {
        this.partnerFilter[field] = value;
      }
    },
    changePartnerFilterType(value, isExist) {
      if (isExist) {
        this.partnerFilter.type = this.partnerFilter.type.filter((item) => item !== value);
      } else {
        this.partnerFilter.type = [...this.partnerFilter.type, value];
      }
    },
  },
};
</script>

<style scoped lang="scss">
.filter-option {
  margin-top: 8px;
  background-color: $N10;
  padding: 8px 16px;
  cursor: pointer;
  text-align: center;
  &.active {
    background-color: $NBLUE110;
    color: $WHITE;
  }
  &:first-child {
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
  }
  &:last-child {
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
  }
}
.filter-btn {
  background-color: $NBLUE110;
  padding: 8px 16px;
  border-radius: 4px;
  display: grid;
  grid-auto-flow: column;
  gap: 8px;
  color: $WHITE;
}
.sb-action {
  display: grid;
  justify-content: center;
  align-items: center;
  gap: 16px;
  position: absolute;
  height: 104px;
  bottom: 0;
  right: 0;
  left: 0;
  background-color: rgba(255, 255, 255, 0.9);
  border-top: 2px solid $N5;
  grid-auto-flow: column;
  .img-circle {
    width: 45px;
    height: 45px;
    border-radius: 50%;
    display: grid;
    align-items: center;
    justify-content: center;
    background-color: $TOMATO100;
    justify-items: center;
    cursor: pointer;
  }
}
</style>
